<app-breadcrumbs></app-breadcrumbs>
<div>
  <div id="meraki-table-wrapper">
    <div [cfaLoading]="isLoading">
      <mat-form-field id="filter-field">
        <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
      <mat-slide-toggle id="offline-toggle" [(ngModel)]="onlyShowOffline" (change)="onToggle()">
        Only show offline
      </mat-slide-toggle>
      <mat-slide-toggle id="lab-toggle" [(ngModel)]="hideLabs" (change)="onToggle()">
        Hide labs
      </mat-slide-toggle>
      <mat-slide-toggle id="future-toggle" [(ngModel)]="hideFutures" (change)="onToggle()">
        Hide Futures
      </mat-slide-toggle>
      <mat-slide-toggle id="remodel-toggle" [(ngModel)]="hideRemodels" (change)="onToggle()">
        Hide Remodels
      </mat-slide-toggle>
    </div>
    <table id="meraki-table" #switchTable mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" matSortActive="storeNumber" matSortDirection="asc">
      <ng-container matColumnDef="storeNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Store Number </th>
        <td mat-cell *matCellDef="let merakiLocation"> {{merakiLocation.location.number}} </td>
      </ng-container>
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
        <td mat-cell *matCellDef="let merakiLocation"> {{merakiLocation.location.name}} </td>
      </ng-container>
      <ng-container matColumnDef="locationStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Status </th>
        <td mat-cell *matCellDef="let merakiLocation"> {{merakiLocation.location.status}} </td>
      </ng-container>
      <ng-container matColumnDef="locationTimeZone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Time Zone </th>
        <td mat-cell *matCellDef="let merakiLocation"> {{merakiLocation.location.timezone}} </td>
      </ng-container>
      <ng-container matColumnDef="merakis">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Switches </th>
        <td mat-cell *matCellDef="let merakiLocation">
          @for (meraki of merakiLocation.merakis; track meraki) {
            <span>
              @if (meraki.status=='online') {
                <mat-icon
                  matTooltip="name: {{meraki.name}}&#13;serial: {{meraki.serial}}&#13;public ip: {{meraki.publicIp}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="meraki-connected-icon">check_circle_outline
                </mat-icon>
              }
              @if (meraki.status=='offline') {
                <mat-icon
                  matTooltip="name: {{meraki.name}}&#13;serial: {{meraki.serial}}&#13;public ip: {{meraki.publicIp}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="meraki-disconnected-icon">highlight_off
                </mat-icon>
              }
            </span>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>